<template>
    <div id="softwares-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Softwares</h1>

                <div class="table-header" style="margin-bottom:20px;">
                    <div class="table-header__tabs"></div>
                    <div class="table-header__controls">
                        <router-link to="/softwares/create" class="table-header__controls__btn">New Software</router-link>
                    </div>
                </div>

                <DataTable class="softwares-data-table"
                           :dataUrl="dataUrl"
                           :displayId="false"
                           :key="tableRefreshKey"
                           :dataFormatter="formatData"
                           :sortable="true"
                           @actionTriggered="actionTriggered">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>

            </section>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/softwares'
import axios from 'axios'

export default {
    name: 'LibrariesIndex',
    components: {
        DataTable
    },
    data: function() {
        return {
            dataUrl: endpoint,
            tableRefreshKey: null
        }
    },
    methods: {
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                const columns = ['_id', 'name', 'code', 'sortId', 'alertMessage', 'alertDescription', 'createdAt', 'updatedAt']

                for (let key of columns) {
                    if (key.includes('At')) {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else if (key === 'alertMessage' || key === 'alertDescription') {
                        let value = obj[key] ?? ''
                        newObj[key] = {
                            'label': key,
                            'value': value.length <= 25 ? value : value.slice(0, 24) + '...',
                            'display_type': 'text'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }

                const actions = {
                    'edit': `<i class="edit-user-action" title="Edit">Edit</i>`,
                    'delete': `<i class="delete-user-action" title="Delete">Delete</i>`
                }
                newObj['actions'] = {
                    'label': '',
                    'value': actions,
                    'display_type': 'actions'
                }

                //const newObjOrdered = Object.assign({'image': ''}, newObj)
                newData.push(newObj)
            }
            return newData
        },
        actionTriggered(actionKey, identifier) {
            if (!identifier) {
                alert('Error occurred #89')
            }
            else if (actionKey == 'edit') {
                this.$router.push('/softwares/' + identifier)
            }
            else if (actionKey == 'delete') {
                if (confirm('Are you sure you want to delete this library?')) {
                    axios.delete(endpoint + '/' + identifier)
                        .then(response => {
                            if (response.data.success === true) {
                                this.tableRefreshKey = Date.now()
                            }
                            else {
                                alert('Error occurred')
                                console.log(response.data.data)
                            }
                        })
                        .catch(error => {
                            alert('Error occurred while deleting')
                            console.log(error)
                        })
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
